import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1b13d0f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "baseline-page" }
const _hoisted_2 = { class: "scan-cntr-outer cm-ui-shadow-container cm-ui-mt16" }
const _hoisted_3 = { class: "scan-cntr" }
const _hoisted_4 = { class: "info-bar cm-ui-ml20" }
const _hoisted_5 = { class: "red-txt" }
const _hoisted_6 = { class: "blue-txt" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scan-cntr-center scan-cntr-center--spacer" }, null, -1))
const _hoisted_8 = { class: "cm-ui-mr20 cm-align-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1776157913924",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "8987",
  width: "20",
  height: "20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M512.5 54c123.228 0 238.798 48.882 324.208 134.292C922.118 273.702 971 389.272 971 512.5c0 123.228-48.882 238.798-134.292 324.208C751.298 922.118 635.728 971 512.5 971c-123.228 0-238.797-48.882-324.209-134.292C102.881 751.298 54 635.728 54 512.5c0-123.228 48.882-238.797 134.292-324.209C273.702 102.881 389.272 54 512.5 54z m0 64c-106.08 0-205.426 42.02-278.954 115.546C160.02 307.074 118 406.42 118 512.5c0 106.08 42.02 205.426 115.546 278.953C307.074 864.98 406.42 907 512.5 907c106.08 0 205.426-42.02 278.953-115.547C864.98 717.926 907 618.58 907 512.5c0-106.08-42.02-205.426-115.547-278.954C717.926 160.02 618.58 118 512.5 118z m-63.975 639.75c-17.673 0-32-14.327-32-32 0-17.496 14.042-31.713 31.47-31.996l0.53-0.004h42.637V459.2h-10.65c-17.496 0-31.713-14.042-31.995-31.47l-0.005-0.53c0-17.496 14.042-31.713 31.471-31.996l0.53-0.004h42.65c17.496 0 31.713 14.042 31.995 31.47l0.005 0.53-0.001 266.55H597.8c17.673 0 32 14.327 32 32 0 17.496-14.042 31.713-31.47 31.996l-0.53 0.004H448.525zM512.5 235.275c29.443 0 53.313 23.87 53.313 53.312 0 29.444-23.87 53.313-53.313 53.313s-53.313-23.87-53.313-53.313 23.87-53.312 53.313-53.312z",
    "p-id": "8988",
    fill: "currentColor"
  })
], -1))
const _hoisted_10 = {
  key: 0,
  class: "scan-cntr__mask",
  "aria-hidden": "true"
}
const _hoisted_11 = {
  key: 1,
  class: "scan-cntr__progress"
}
const _hoisted_12 = { class: "scan-task-banner__text" }
const _hoisted_13 = { class: "scan-task-banner__sub" }
const _hoisted_14 = { class: "baseline-preview-card-actions" }

import { ref, reactive, computed, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { Loading } from '@element-plus/icons'
import { interval, merge, of, Subscription } from 'rxjs'
import { map } from 'rxjs/operators'
import StatisticsCards from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'
import { StatisticsCardItem } from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'
import Card from '@/views/dashboard/_components/card/card.vue'
import BaseLineScanTerminalDrawer from '@/views/dashboard/safe-status/base-line/_components/baseLine-scan-terminal-drawer/baseLine-scan-terminal-drawer.vue'
import BaseLineRepairDrawer from '@/views/dashboard/safe-status/base-line/_components/baseLine-repair-drawer/baseLine-repair-drawer.vue'
import BaselineCategoryBarChart from './_components/baseline-category-bar-chart/baseline-category-bar-chart.vue'
import BaselineTerminalTopRanking from './_components/baseline-terminal-top-ranking/baseline-terminal-top-ranking.vue'
import BaselineTerminalTable from './_components/baseline-terminal-table/baseline-terminal-table.vue'
import BaselineCheckItemTable from './_components/baseline-check-item-table/baseline-check-item-table.vue'
import BaselineIgnoredTable from './_components/baseline-ignored-table/baseline-ignored-table.vue'
import BaselineDetail from './_components/base-line-detail/base-line-detail.vue'
import CmSvgIcon from '@/components/cm-svg-icon/cm-svg-icon.vue'
import {
  BaseLineService,
  BaseLineItem,
  BaselineCheckItemStatRow,
  FetchOptions,
  BaselineTerminalDrawerInitialPatch,
  ScanParams
} from '@/views/dashboard/safe-status/base-line/base-line.service'
import {
  BaseLineHeaderService,
  StatsData,
  BaselineCategoryTopItem,
  BaselineTerminalTopItem
} from '@/views/dashboard/safe-status/base-line/_components/base-line-header/base-line-header.service'
import {
  BaseLineScanTerminalDrawerService,
  ScanResult
} from '@/views/dashboard/safe-status/base-line/_components/baseLine-scan-terminal-drawer/baseLine-scan-terminal-drawer.service'
import { TableViewMode } from '@/views/dashboard/_enum/table-view-mode'
import {
  getBaselineCheckItemLabelsById,
  resolveCheckItemNonComplianceCount
} from '@/views/dashboard/safe-status/base-line/baseline-repair-items-cache'

const DEFAULT_GROUP = -1
const SECONDS = 1000
const SCAN_TIME_CONSTANT = 'baseLine-scanTime'
const REPAIR_TIME_CONSTANT = 'baseLine-repairTime'
const SCAN_POLL_MS = 3000

const BASELINE_STALE_SCAN_DAYS = 7


export default /*#__PURE__*/_defineComponent({
  __name: 'base-line',
  setup(__props) {

const { t, locale } = useI18n()
const route = useRoute()
const injector = useReflectiveInjector([
  BaseLineService,
  BaseLineHeaderService,
  BaseLineScanTerminalDrawerService
])
const baseLineService = injector.get(BaseLineService)
const headerService = injector.get(BaseLineHeaderService)
const scanTerminalService = injector.get(BaseLineScanTerminalDrawerService)

let countTimer: Subscription | null = null
let scanPollTimer: ReturnType<typeof setInterval> | null = null
let repairPollTimer: ReturnType<typeof setInterval> | null = null

const storedScanId = localStorage.getItem('BASELINE_SCAN_TASK_ID')
const scanTaskIdRef = ref<string>(storedScanId || '')
const storedRepairId = localStorage.getItem('BASELINE_REPAIR_TASK_ID')
const repairTaskIdRef = ref<string>(storedRepairId || '')

const scanTime = ref(0)
const repairTime = ref(0)
const isScan = ref(false)
const isRepair = ref(false)
const baselineScanDrawerVisible = ref(false)
const baselineRepairDrawerVisible = ref(false)

const scanResult = reactive<ScanResult>({
  is_finish: !storedScanId,
  substandard_count: 0,
  check_total: 0
})

const repairResult = reactive({
  is_finish: !storedRepairId,
  repair_total: 0
})

const baselineTasking = computed(() => isScan.value || isRepair.value)
const router = useRouter()
function openBaselineConfigHelp () {
  window
}

const taskBannerLine1 = computed(() => {
  if (!baselineTasking.value) return ''
  const action = isScan.value ? t('safeProtectionModule.baselineScan') : t('safeProtectionModule.baselineFix')
  return t('safeProtectionModule.baselineScanning', { action })
})

const taskBannerLine2 = computed(() => {
  if (!baselineTasking.value) return ''
  if (isScan.value) {
    return t('safeProtectionModule.baselineProgress', {
      action: t('safeProtectionModule.baselineScan'),
      n: scanResult.check_total,
      sec: scanTime.value
    })
  }
  return t('safeProtectionModule.baselineProgress', {
    action: t('safeProtectionModule.baselineFix'),
    n: repairResult.repair_total,
    sec: repairTime.value
  })
})

function clearCountTimer () {
  countTimer?.unsubscribe()
  countTimer = null
}

function clearScanPoll () {
  if (scanPollTimer != null) {
    clearInterval(scanPollTimer)
    scanPollTimer = null
  }
}

function clearRepairPoll () {
  if (repairPollTimer != null) {
    clearInterval(repairPollTimer)
    repairPollTimer = null
  }
}

function handleScanTime (name: string) {
  clearCountTimer()
  let sed = 0
  if (localStorage.getItem(name)) {
    sed = Math.ceil((Date.now() - Number(localStorage.getItem(name))) / SECONDS)
  }
  countTimer = merge(of(sed), interval(SECONDS).pipe(map(i => i + sed)))
    .pipe(map(i => i + 1))
    .subscribe(n => {
      if (name === SCAN_TIME_CONSTANT) {
        scanTime.value = n
      } else {
        repairTime.value = n
      }
    })
}

function handleDoRepair (taskId: string) {
  clearRepairPoll()
  handleScanTime(REPAIR_TIME_CONSTANT)
  isRepair.value = true
  repairPollTimer = setInterval(() => {
    headerService.getRepairResult({ task_id: taskId }).then(res => {
      if (res.is_finish) {
        ElMessage.success(t('safeProtectionModule.autoFixComplete'))
        clearCountTimer()
        isRepair.value = false
        repairTaskIdRef.value = ''
        localStorage.removeItem('BASELINE_REPAIR_TASK_ID')
        localStorage.removeItem(REPAIR_TIME_CONSTANT)
        clearRepairPoll()
        loadStats()
        handleGlobalRefresh()
      }
      Object.assign(repairResult, res)
    })
  }, SCAN_POLL_MS)
}

function handleDoScan (taskId: string) {
  clearScanPoll()
  handleScanTime(SCAN_TIME_CONSTANT)
  isScan.value = true
  scanPollTimer = setInterval(() => {
    scanTerminalService.getScanResult({ task_id: taskId }).then(res => {
      if (res.is_finish) {
        clearCountTimer()
        isScan.value = false
        scanTaskIdRef.value = ''
        ElMessage.success(t('safeProtectionModule.scanComplete'))
        localStorage.removeItem('BASELINE_SCAN_TASK_ID')
        localStorage.removeItem(SCAN_TIME_CONSTANT)
        clearScanPoll()
        loadStats()
        handleGlobalRefresh()
      }
      Object.assign(scanResult, res)
    })
  }, SCAN_POLL_MS)
}

function openBaselineScanDrawer () {
  baselineScanDrawerVisible.value = true
}

function openBaselineRepairDrawer () {
  baselineRepairDrawerVisible.value = true
}

function closeBaselineScanDrawer () {
  baselineScanDrawerVisible.value = false
}

function closeBaselineRepairDrawer () {
  baselineRepairDrawerVisible.value = false
}

function onSyncScanTaskId (id: string) {
  isScan.value = true
  scanResult.is_finish = false
  scanTaskIdRef.value = id
  localStorage.setItem(SCAN_TIME_CONSTANT, String(Date.now()))
  handleDoScan(id)
}

function onSyncScanDeviceCount (count: number) {
  scanResult.check_total = count
}

function onSyncRepairTaskId (id: string) {
  isRepair.value = true
  repairResult.is_finish = false
  repairTaskIdRef.value = id
  localStorage.setItem(REPAIR_TIME_CONSTANT, String(Date.now()))
  handleDoRepair(id)
}

function onBaselineDrawerAuthSuccess () {
  handleGlobalRefresh()
}

const terminalPreviewRef = ref<{ getList?: () => void } | null>(null)
const checkItemPreviewRef = ref<{
  getList?: () => void
  batchIgnore?: () => void | Promise<void>
  selectedCount?: number
} | null>(null)
const ignoredPreviewRef = ref<{
  getList?: () => void
  batchCancelIgnore?: () => void
  selectedCount?: number
} | null>(null)

const statsLoading = ref(false)
const stats = reactive<StatsData>({
  substandard_num: 0,
  last_uncheck_num: 0,
  non_compliance_total: 0,
  compliance_rate: undefined
})

const terminalChartTop5 = ref<BaselineTerminalTopItem[]>([])
const terminalChartLoading = ref(true)

const categoryChartTop5 = ref<BaselineCategoryTopItem[]>([])
const categoryChartLoading = ref(true)

const terminalDrawerVisible = ref(false)
const terminalDrawerKey = ref(0)
const terminalDrawerQueryPatch = ref<BaselineTerminalDrawerInitialPatch>({})

const terminalDrawerTitleResolved = computed(() => {
  void locale.value
  const base = t('baselineDashboard.drawerAllTerminals')
  const custom = terminalDrawerQueryPatch.value?.drawerTitle
  const suffix = custom != null ? String(custom).trim() : ''
  return suffix !== '' ? `${base} [${suffix}]` : base
})

const checkItemDrawerVisible = ref(false)
const checkItemDrawerKey = ref(0)
const ignoredDrawerVisible = ref(false)
const ignoredDrawerKey = ref(0)

const baselineDetailDrawer = ref(false)
const baseLineData = reactive({
  currentDevice: {} as BaseLineItem
})

function onTerminalPreviewChartRows (rows: BaselineTerminalTopItem[]) {
  terminalChartTop5.value = rows
  terminalChartLoading.value = false
}

const statisticsItems = computed<StatisticsCardItem[]>(() => {
  void locale.value
  const s = stats
  return BASELINE_STAT_CARD_CONFIG.map((cfg) => {
    const value = cfg.getValue(s)
    const drill = cfg.drillDown === true
    const num = typeof value === 'number' ? value : 0
    return {
      label: t(cfg.labelKey),
      value,
      ...(drill ? { tip: t('baselineDashboard.viewMore') } : {}),
      clickable: drill && num > 0,
      events: {
        click: () => {
          drill && num > 0 && cfg.openDrawer?.()
        },
      },
    }
  })
})

function loadStats () {
  statsLoading.value = true
  headerService
    .getBaseLineCheckResultStats()
    .then(res => {
      stats.substandard_num = res.substandard_num
      stats.last_uncheck_num = res.last_uncheck_num
      stats.non_compliance_total = res.non_compliance_total ?? 0
      stats.compliance_rate = res.compliance_rate
    })
    .finally(() => {
      statsLoading.value = false
    })
}

function loadCategoryChart () {
  categoryChartLoading.value = true
  baseLineService
    .getCheckItemStatList({
      page: 1,
      limit: 5,
      sort: 'substandard_terminal_count',
      asc: false
    })
    .then(res => {
      void locale.value
      const rows = res.data ?? (res as { list?: BaselineCheckItemStatRow[] }).list ?? []
      categoryChartTop5.value = rows.slice(0, 5).map(row => {
        const c = getBaselineCheckItemLabelsById(row.check_item_id)
        return {
          check_item_id: row.check_item_id,
          category_name: c.itemName || row.item_name || row.check_item_id || '--',
          terminal_count: resolveCheckItemNonComplianceCount(row)
        }
      })
    })
    .catch(() => {
      categoryChartTop5.value = []
    })
    .finally(() => {
      categoryChartLoading.value = false
    })
}

function handleGlobalRefresh () {
  terminalChartLoading.value = true
  loadStats()
  loadCategoryChart()
  terminalPreviewRef.value?.getList?.()
  checkItemPreviewRef.value?.getList?.()
  ignoredPreviewRef.value?.getList?.()
}

/** 与 stats 卡顺序一致：取数、打开终端抽屉 / 检测项抽屉（对齐 examination 页配置表，避免 index 链式 if） */
function formatStatComplianceRate (rate: number | undefined): string {
  if (rate == null || Number.isNaN(rate)) return '--'
  return `${Number(rate).toFixed(1)}%`
}

const BASELINE_STAT_CARD_CONFIG = [
  {
    labelKey: 'baselineDashboard.statViolationTerminals' as const,
    getValue: (s: StatsData) => s.substandard_num,
    drillDown: true as const,
    openDrawer: (): void => {
      openTerminalDrawer({ check_result: 2 })
    },
  },
  {
    labelKey: 'baselineDashboard.statStaleScan' as const,
    getValue: (s: StatsData) => s.last_uncheck_num,
    drillDown: true as const,
    openDrawer: (): void => {
      openTerminalDrawer({
        unscanned_over_days: BASELINE_STALE_SCAN_DAYS,
        drawerTitle: t('baselineDashboard.statStaleScan'),
      })
    },
  },
  {
    labelKey: 'baselineDashboard.statViolationItems' as const,
    getValue: (s: StatsData) => s.non_compliance_total ?? 0,
    drillDown: true as const,
    openDrawer: (): void => {
      openCheckItemDrawer()
    },
  },
  {
    labelKey: 'baselineDashboard.statComplianceRate' as const,
    getValue: (s: StatsData) => formatStatComplianceRate(s.compliance_rate),
    drillDown: false as const,
  },
] as const

function openTerminalDrawer (patch?: BaselineTerminalDrawerInitialPatch) {
  terminalDrawerQueryPatch.value = patch ? { ...patch } : {}
  terminalDrawerKey.value += 1
  terminalDrawerVisible.value = true
}

/** 检测项 TOP：点击不合规终端数，按该检测项（check_item_id）筛终端列表 */
function openTerminalDrawerNonCompliant (row?: BaselineCheckItemStatRow) {
  const sid = row?.check_item_id != null && String(row.check_item_id).trim() !== ''
    ? String(row.check_item_id).trim()
    : undefined
  openTerminalDrawer({
    check_result: 2,
    ...(sid ? { substandard_id: sid, hideComplianceFilter: true } : {})
  })
}

/** 分类 TOP5 柱状图：点击柱体该检测项的不合规终端 */
function onCategoryChartBarClick (item: BaselineCheckItemStatRow) {
  if (item.check_item_id) {
    openTerminalDrawer(terminalDrawerPatchForCheckItem(item, true))
  }
}

function terminalDrawerPatchForCheckItem (
  row: BaselineCheckItemStatRow,
  withRepairCheckItem: boolean,
): BaselineTerminalDrawerInitialPatch {
  void locale.value
  const sid = row?.check_item_id != null ? String(row.check_item_id).trim() : ''
  const labels = getBaselineCheckItemLabelsById(row.check_item_id)
  const itemLabel = labels.itemName || row.item_name || row.check_item_id || '--'
  return {
    check_result: 2,
    substandard_id: sid || undefined,
    hideComplianceFilter: true,
    hideTerminalRowActions: true,
    drawerTitle: itemLabel,
    ...(withRepairCheckItem && sid ? { repairCheckItemId: sid } : {}),
  }
}

/** 检测项列表 / 已忽略列表：详情 = 不合规 + 指定检测项终端，并隐藏「是否合规」筛选 */
function openIgnoredDetailToTerminals (row: BaselineCheckItemStatRow) {
  openTerminalDrawer(terminalDrawerPatchForCheckItem(row, false))
}

/** 检测项列表：修复 = 与详情相同终端列表 + 工具栏针对当前检测项批量修复 */
function openRepairTerminalsDrawer (row: BaselineCheckItemStatRow) {
  openTerminalDrawer(terminalDrawerPatchForCheckItem(row, true))
}

function openCheckItemDrawer () {
  checkItemDrawerKey.value += 1
  checkItemDrawerVisible.value = true
}

function openIgnoredDrawer () {
  ignoredDrawerKey.value += 1
  ignoredDrawerVisible.value = true
}

function openDetailView (device: BaseLineItem) {
  baseLineData.currentDevice = device
  baselineDetailDrawer.value = true
}

function repairTerminalRow (data: BaseLineItem) {
  const params: ScanParams = { select_type: 1, device_list: [data.device_id], group_id: DEFAULT_GROUP }
  baseLineService
    .getBaseLineCheckCheck(params)
    .then(response => {
      if (data.device_status === 1) {
        localStorage.setItem('BASELINE_SCAN_TASK_ID', response.task_id)
        scanTaskIdRef.value = response.task_id
        handleDoScan(response.task_id)
        ElMessage.success({ message: t('safeProtectionModule.rescanSuccess'), center: true })
      } else {
        ElMessage.warning({ message: t('safeProtectionModule.rescanPendingReboot'), center: true })
      }
    })
    .catch(() => {
      ElMessage.error(t('safeProtectionModule.rescanFail'))
    })
}

onMounted(() => {
  loadStats()
  loadCategoryChart()
  baseLineService.getAllBaselineItems()
  if (scanTaskIdRef.value) {
    handleDoScan(scanTaskIdRef.value)
  }
  if (repairTaskIdRef.value) {
    handleDoRepair(repairTaskIdRef.value)
  }
  const cr = Number(route.query.check_result)
  if (cr === 1 || cr === 2) {
    openTerminalDrawer({ check_result: cr })
  }
  if (String(route.query.open_check_item_drawer || '') === '1') {
    openCheckItemDrawer()
  }
})

onUnmounted(() => {
  clearCountTimer()
  clearScanPoll()
  clearRepairPoll()
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(StatisticsCards, { items: statisticsItems.value }, null, 8, ["items"]), [
      [_directive_loading, statsLoading.value]
    ]),
    _createVNode(_component_el_row, {
      gutter: 16,
      class: "charts-row cm-ui-mt16"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(BaselineCategoryBarChart, {
              data: categoryChartTop5.value,
              loading: categoryChartLoading.value,
              onCategoryClick: onCategoryChartBarClick
            }, null, 8, ["data", "loading"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(BaselineTerminalTopRanking, {
              data: terminalChartTop5.value,
              loading: terminalChartLoading.value,
              onDetail: openDetailView
            }, null, 8, ["data", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(CmSvgIcon, {
            class: "info-tips cm-ui-mr10",
            name: "assets/icons/summary-stat",
            size: 22,
            color: "var(--el-color-primary)"
          }),
          _createVNode(_component_i18n_t, {
            keypath: "baselineDashboard.baselineSummaryLine",
            tag: "span"
          }, {
            item: _withCtx(() => [
              _createElementVNode("span", _hoisted_5, _toDisplayString(stats.non_compliance_total ?? 0), 1)
            ]),
            terminal: _withCtx(() => [
              _createElementVNode("span", _hoisted_6, _toDisplayString(stats.substandard_num), 1)
            ]),
            _: 1
          })
        ]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_tooltip, {
            content: _ctx.$t('safeProtectionModule.baselineConfigHelp'),
            placement: "top",
            effect: "light"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_link, {
                type: "primary",
                underline: false,
                target: "_blank",
                href: "/help/repair-help",
                class: "cm-ui-cursor-pointer cm-ui-mr10"
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["content"]),
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            disabled: baselineTasking.value,
            onClick: openBaselineScanDrawer
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.baselineStartScan')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            size: "small",
            disabled: baselineTasking.value,
            onClick: openBaselineRepairDrawer
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.baselineFixNow')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      (baselineTasking.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10))
        : _createCommentVNode("", true),
      (baselineTasking.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_el_icon, { class: "scan-task-banner__icon is-loading" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Loading))
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", null, _toDisplayString(taskBannerLine1.value), 1),
              _createElementVNode("div", _hoisted_13, _toDisplayString(taskBannerLine2.value), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _createVNode(Card, {
        size: "second",
        class: "cm-ui-mt16",
        title: _ctx.$t('baselineDashboard.detectionListTop10')
      }, {
        titleAfter: _withCtx(() => [
          _createVNode(_component_el_tag, { size: "small" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.listPreviewRecent10')), 1)
            ]),
            _: 1
          })
        ]),
        headerRight: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              plain: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (openCheckItemDrawer()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('commonPage.viewAll')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(BaselineCheckItemTable, {
            ref_key: "checkItemPreviewRef",
            ref: checkItemPreviewRef,
            "view-mode": _unref(TableViewMode).preview,
            onViewAll: _cache[1] || (_cache[1] = ($event: any) => (openCheckItemDrawer())),
            onDetail: openIgnoredDetailToTerminals,
            onRepairTerminals: openRepairTerminalsDrawer,
            onTerminalCountClick: _cache[2] || (_cache[2] = ($event: any) => (openTerminalDrawerNonCompliant($event))),
            onRefresh: handleGlobalRefresh
          }, null, 8, ["view-mode"])
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(Card, {
        size: "second",
        class: "cm-ui-mt16",
        title: _ctx.$t('baselineDashboard.terminalListTop10')
      }, {
        titleAfter: _withCtx(() => [
          _createVNode(_component_el_tag, { size: "small" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.listPreviewRecent10')), 1)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(BaselineTerminalTable, {
            ref_key: "terminalPreviewRef",
            ref: terminalPreviewRef,
            "view-mode": _unref(TableViewMode).preview,
            onViewAll: _cache[3] || (_cache[3] = ($event: any) => (openTerminalDrawer())),
            onDetail: openDetailView,
            onRepair: repairTerminalRow,
            onBatchRepair: openBaselineRepairDrawer,
            onRefresh: handleGlobalRefresh,
            onPreviewChartRows: onTerminalPreviewChartRows
          }, null, 8, ["view-mode"])
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _createVNode(_component_el_drawer, {
      size: "75%",
      modelValue: baselineScanDrawerVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((baselineScanDrawerVisible).value = $event)),
      direction: "rtl",
      title: _ctx.$t('safeProtectionModule.rescanTitle'),
      "destroy-on-close": "",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _createVNode(BaseLineScanTerminalDrawer, {
          onSyncScanTaskId: onSyncScanTaskId,
          onSyncScanDeviceCount: onSyncScanDeviceCount,
          onCloseTerminalDrawer: closeBaselineScanDrawer,
          onAuthSuccess: onBaselineDrawerAuthSuccess
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_drawer, {
      size: "75%",
      modelValue: baselineRepairDrawerVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((baselineRepairDrawerVisible).value = $event)),
      direction: "rtl",
      title: _ctx.$t('safeProtectionModule.fixTitle'),
      "destroy-on-close": "",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _createVNode(BaseLineRepairDrawer, {
          onSyncRepairTaskId: onSyncRepairTaskId,
          onCloseRepairDrawer: closeBaselineRepairDrawer,
          onAuthSuccess: onBaselineDrawerAuthSuccess
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_drawer, {
      modelValue: terminalDrawerVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((terminalDrawerVisible).value = $event)),
      "custom-class": "no-body-margin",
      size: "80%",
      title: terminalDrawerTitleResolved.value,
      "destroy-on-close": "",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(BaselineTerminalTable, {
          key: terminalDrawerKey.value,
          "view-mode": _unref(TableViewMode).full,
          "initial-query-patch": terminalDrawerQueryPatch.value,
          onDetail: openDetailView,
          onRepair: repairTerminalRow,
          onBatchRepair: openBaselineRepairDrawer,
          onSyncRepairTaskId: onSyncRepairTaskId,
          onRefresh: handleGlobalRefresh
        }, null, 8, ["view-mode", "initial-query-patch"]))
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_drawer, {
      modelValue: checkItemDrawerVisible.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((checkItemDrawerVisible).value = $event)),
      size: "80%",
      title: _ctx.$t('baselineDashboard.drawerAllDetectionItems'),
      "destroy-on-close": "",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(BaselineCheckItemTable, {
          key: checkItemDrawerKey.value,
          "view-mode": _unref(TableViewMode).full,
          onDetail: openIgnoredDetailToTerminals,
          onRepairTerminals: openRepairTerminalsDrawer,
          onTerminalCountClick: _cache[7] || (_cache[7] = ($event: any) => (openTerminalDrawerNonCompliant($event))),
          onRefresh: handleGlobalRefresh
        }, null, 8, ["view-mode"]))
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_drawer, {
      modelValue: ignoredDrawerVisible.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((ignoredDrawerVisible).value = $event)),
      size: "80%",
      title: _ctx.$t('baselineDashboard.drawerAllIgnored'),
      "destroy-on-close": "",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(BaselineIgnoredTable, {
          key: ignoredDrawerKey.value,
          "view-mode": _unref(TableViewMode).full,
          style: {"padding":"10px 16px","height":"100%"},
          onDetail: openIgnoredDetailToTerminals,
          onRefresh: handleGlobalRefresh
        }, null, 8, ["view-mode"]))
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_drawer, {
      modelValue: baselineDetailDrawer.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((baselineDetailDrawer).value = $event)),
      size: "47%",
      direction: "rtl",
      title: _ctx.$t('safeProtectionModule.scanDetail'),
      "destroy-on-close": "",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _createVNode(BaselineDetail, {
          "current-device": baseLineData.currentDevice
        }, null, 8, ["current-device"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})